import { render, staticRenderFns } from "./agreement-detail-modal.vue?vue&type=template&id=65541682&scoped=true&"
import script from "./agreement-detail-modal.vue?vue&type=script&lang=js&"
export * from "./agreement-detail-modal.vue?vue&type=script&lang=js&"
import style0 from "./agreement-detail-modal.vue?vue&type=style&index=0&id=65541682&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65541682",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65541682')) {
      api.createRecord('65541682', component.options)
    } else {
      api.reload('65541682', component.options)
    }
    module.hot.accept("./agreement-detail-modal.vue?vue&type=template&id=65541682&scoped=true&", function () {
      api.rerender('65541682', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/agreement-detail-modal.vue"
export default component.exports